import moment from 'moment';

// Unzoned database DATETIME values are stored in India time (+05:30).
// ISO timestamps already carry their offset and must not be shifted twice.
export const formatUtcDate = (value) => {
  if (!value) return '—';
  let date;
  if (value instanceof Date || typeof value === 'number') date = moment(value);
  else {
    const text = String(value).trim();
    const zoned = /(?:Z|[+-]\d{2}:?\d{2})$/i.test(text);
    date = moment.parseZone(zoned ? text : `${text.replace(' ', 'T')}+05:30`, moment.ISO_8601, true);
  }
  return date.isValid() ? date.utc().format('DD MMM YYYY, HH:mm:ss [UTC]') : '—';
};
